<template>
  <div class="liu" v-wechat-title="'身份认证'">
    <div>
      <!-- 身份证 -->
      <div class="color-f-bg">
        <div class="say-color page-padding-l-r padding-t-10 padding-b-10 title-5">请拍摄本人的身份证证件</div>
        <div class="flex say-color title-5">
          <!-- 人像面 -->
          <div class="flex-1 align-center">
            <div @click="cameraImgClick('renXiang')">
              <img :src="renXiang.webUrl" class="idCardStyle" v-if="renXiang.webUrl" />
              <svg-icon v-else icon-class="authenticate-headshot" class-name="idCardStyle"></svg-icon>
            </div>
            <div class="padding-t-10">人像面</div>
          </div>
          <!-- 国徽面 -->
          <div class="flex-1 align-center">
            <div @click="cameraImgClick('guoHui')">
              <img :src="guoHui.webUrl" class="idCardStyle" v-if="guoHui.webUrl" />
              <svg-icon v-else icon-class="authenticate-emblem" class-name="idCardStyle"></svg-icon>
            </div>
            <div class="padding-t-10">国徽面</div>
          </div>
        </div>
        <!-- 身份信息 -->
        <div class="page-padding-l-r padding-t-10">
          <mt-field label="商户姓名" placeholder="请输入商户姓名" v-if="renXiang.webUrl"
            v-model.trim="formData.idCardName"></mt-field>
          <mt-field label="法人身份证" placeholder="请输入法人身份证" v-if="renXiang.webUrl" v-model.trim="formData.idCardNum"
            disabled></mt-field>
          <mt-field label="有效期" placeholder="请输入有效期" v-if="guoHui.webUrl" v-model.trim="formData.dateOf"
            disabled></mt-field>
        </div>
      </div>
      <!-- 活体 -->
      <div v-if="btnStatus != 1" class="page-padding-l-r padding-t-10 padding-b-10 margin-t-10 flex-s color-f-bg">
        <div style="width: 105px">人脸识别</div>
        <div @click="cameraImgClick('renLian')">
          <img :src="renLian.webUrl" class="faceStyle" v-if="renLian.webUrl" />
          <svg-icon icon-class="camera_face" class-name="faceStyle" v-else></svg-icon>
        </div>
      </div>
      <!-- 提示1 -->
      <div class="flex page-padding-l-r padding-t-10 padding-b-10 say-color title-6"
        v-if="(renXiang.webUrl || guoHui.webUrl) && btnStatus != 3">
        <div class="flex-1">
          <div class="say-color" v-if="btnStatus == 1 || (btnStatus == 2 && renLian.webUrl)">
            如信息有误，请重新拍照
          </div>
          <div class="say-color" v-else>
            {{ renLian.photoTips }}
          </div>
        </div>
        <div>
          <div class="theme-color" bindtap="resetCamera" v-if="btnStatus == 1 || (btnStatus == 2 && renLian.webUrl)"
            @click="resetCameraInfo('renXiang'), resetCameraInfo('guoHui'), resetCameraInfo('renLian')">{{ btnStatus ==
              1 ? "重新拍照" : "重新认证" }}</div>
        </div>
      </div>
      <!-- 提示2 -->
      <div class="page-padding-l-r padding-t-10 padding-b-10 say-color title-6" v-if="btnStatus == 3">
        如遇活体检测失败，可以选择
        <span class="theme-color" @click="resetCameraInfo('renLian', 3)">重新识别</span>或
        <span class="theme-color" @click="jumpManualAudit()">申请人工审核</span>
      </div>
      <!-- 提交按钮 -->
      <div class="padding-t-10 padding-b-10 page-padding-l-r">
        <mt-button type="primary" size="large" v-if="renXiang.webUrl && guoHui.webUrl"
          :disabled="btnStatus >= 2 && !renLian.webUrl" @click="submitData">{{ btnName }}</mt-button>
      </div>
    </div>
    <!-- 百度活体弹窗 -->
    <mt-popup class="liveness-popup" v-model="livingFacePopupVisible" :closeOnClickModal="false">
      <liveness ref="liveness"></liveness>
    </mt-popup>
  </div>
</template>

<script>
/* global PUBLIC_FACE_PHOTO_TIPS */
/* global wx */

import SvgIcon from '@/components/SvgIcon';
import Liveness from '@/components/Liveness';
import { mapGetters, mapMutations } from 'vuex';
import { formatDateId, formatDateLongStr } from '@/utils/utils.js';
import { CusToast, CusAlert, CusLoadingOpen, CusLoadingClose } from '@/utils/CustomToast';
import { GetIdCardFrontUrlV2, GetIdCardBackUrlV2, GetIdNameFaceServiceUrl, UpdateIdCardInfoFaceActive, YMTivingThing } from '@/api/weChat.js';
import { SucceedHandle2, NotSucceedHandle } from '@/api/handle';

export default {
  name: 'IdCardInfo',
  components: { SvgIcon, Liveness },
  data() {
    return {
      // 身份证人像面
      renXiang: {
        type: '',
        base64: '',
        fileUrl: '',
        webUrl: '',
      },
      // 身份证国徽面
      guoHui: {
        type: '',
        base64: '',
        fileUrl: '',
        webUrl: '',
      },
      // 人脸照片
      renLian: {
        type: '',
        base64: '',
        fileUrl: '',
        webUrl: '',
        popupVisible: false,
        photoTips: PUBLIC_FACE_PHOTO_TIPS,
      },
      // 表单数据
      formData: {
        idCardName: '',
        idCardNum: '',
        address: '',
        familyName: '',
        birthday: '',
        sex: '',
        office: '',
        dateOfIssue: '',
        dateOfInvalid: '',
        dateOf: '',
      },
      // 按钮当前的状态
      btnStatus: 1,
      // 百度活体弹窗开关
      livingFacePopupVisible: false,
      // token
      token: '',
      // 用户手机号
      mobile: '',
      // 产品标识
      product: '',
      // 是否需要活体认证
      faceDetectActivity: 0,
      // 是否需要手持
      userIsNeedHandIdentityCard: false,
      // 身份证识别批次号 2023.4.23
      idCardBatchNo: '',
    };
  },
  computed: {
    ...mapGetters(['livingFaceImgUrl', 'livingFacePopupStatus']),
    // 按钮状态名称
    btnName() {
      let name = '提交';
      switch (this.btnStatus) {
        case 1:
          name = '提交';
          break;
        default:
          name = '下一步';
      }
      return name;
    },
  },
  watch: {
    livingFaceImgUrl(val) {
      this.renLian.base64 = val;
      this.renLian.fileUrl = val;
      this.renLian.webUrl = val;
    },
    livingFacePopupStatus(val) {
      this.livingFacePopupVisible = val;
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.token = this.$route.query.token;
      this.mobile = this.$route.query.mobile;
      this.product = this.$route.query.product;
      this.faceDetectActivity = parseInt(this.$route.query.faceDetectActivity);
      this.userIsNeedHandIdentityCard = this.$route.query.userIsNeedHandIdentityCard === 'true';
      this.idCardBatchNo = `${formatDateLongStr(new Date())}${String(Math.floor(Math.random() * 9000000000000 + 1000000000000))}`;
      const imgType = this.$route.query.imgType;
      if (imgType) {
        this.btnStatus = parseInt(this.$route.query.btnStatus);
        this.idCardBatchNo = this.$route.query.idCardBatchNo;
        this.renXiang.webUrl = decodeURIComponent(this.$route.query.rxWebUrl).replace('|', '?');
        this.guoHui.webUrl = decodeURIComponent(this.$route.query.ghWebUrl).replace('|', '?');
        this.renLian.webUrl = decodeURIComponent(this.$route.query.rlWebUrl).replace('|', '?');
        this.formData.idCardName = this.$route.query.idCardName;
        this.formData.idCardNum = this.$route.query.idCardNum;
        this.formData.address = this.$route.query.address;
        this.formData.birthday = this.$route.query.birthday;
        this.formData.sex = this.$route.query.sex;
        this.formData.office = this.$route.query.office;
        this.formData.dateOfIssue = this.$route.query.dateOfIssue;
        this.formData.dateOfInvalid = this.$route.query.dateOfInvalid;
        this.formData.dateOf = this.$route.query.dateOf;
        switch (imgType) {
          case "renXiang":
            if (this.renXiang.webUrl) {
              this.getIdCardFrontUrlV2();
            }
            break;
          case "guoHui":
            if (this.guoHui.webUrl) {
              this.getIdCardBackUrlV2();
            }
            break;
          case "ymt":
            if (this.renLian.webUrl) {
              this.yMTivingThing();
            }
            break;
          case "renLian":
            break;
        }
      }
    });
  },
  methods: {
    ...mapMutations(['setLivingFacePopupStatus']),
    // 调用接口上传人脸照片
    updateIdCardInfoFaceActive(url, callback = null) {
      const batchNumber = Math.floor(Math.random() * 900000000 + 100000000);
      UpdateIdCardInfoFaceActive({ url, batchNumber })
        .then(res => {
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              callback && callback();
            },
            () => {
              callback && callback();
            }
          );
        })
        .catch(err => {
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 活体识别
    renLianInfo() {
      const mobile = this.$route.query.mobile || 99999999999;
      const discernFaceDate = parseInt(sessionStorage.getItem('discernFaceDate')) || 0;
      const currentDateId = parseInt(formatDateId(new Date()));
      if (discernFaceDate !== currentDateId) {
        sessionStorage.setItem('discernFaceDate', currentDateId);
        sessionStorage.setItem(`${mobile}_facecount`, 0);
      }
      const faceCount = parseInt(sessionStorage.getItem(`${mobile}_facecount`)) || 0;
      const faceMaxCount = parseInt(this.$route.query.facemax) || 50;
      if (faceCount < faceMaxCount) {
        const faceCountDiffer = faceMaxCount - faceCount;
        if (faceCountDiffer < 3) {
          // 请确定是否为身份证本人的人脸信息。
          CusAlert(`您今天人脸识别次数还剩${faceCountDiffer}次机会`, () => {
            this.jumpToLiveness();
          });
        } else {
          this.jumpToLiveness();
        }
      } else {
        CusAlert('今天人脸识别次数已达上限，请明天再试');
      }
    },
    // 拍照组件点击事件
    cameraImgClick(type) {
      switch (type) {
        case "renXiang":
        case "guoHui":
          const data = this.createPostMessage(type);
          wx.miniProgram.postMessage({ data });
          wx.miniProgram.redirectTo({
            url: '/pages/media/media',
          });
          break;
        case "renLian":
          this.renLianInfo();
          break;
      }
    },
    // 提交数据
    submitData() {
      switch (this.btnStatus) {
        case 1:
          this.btnStatus = 3;
          break;
        case 2:
          this.upLoadData();
          break;
        case 3:
          this.upLoadData();
          break;
      }
    },
    // 上传数据到服务器
    upLoadData() {
      const data = {};
      data.url = this.renLian.webUrl;
      data.batchNo = this.idCardBatchNo;
      CusLoadingOpen();
      GetIdNameFaceServiceUrl(data)
        .then(res => {
          CusLoadingClose();
          if (res.code === 0) {
            this.updateIdCardInfoFaceActive(this.renLian.webUrl, () => {
              if (this.userIsNeedHandIdentityCard) {
                //  如果需要手持，则跳转手持页面
                this.replacePage('HandIdCard', {
                  idCardName: this.formData.idCardName,
                  idCardNum: this.formData.idCardNum,
                  token: this.token,
                  product: this.product,
                });
              } else {
                // 不需要手持，则跳转回小程序的结算卡添加页面
                wx.miniProgram.redirectTo({
                  url: `/pages/bankCard/savingsCard/savingsCard?idCardName=${this.formData.idCardName}&flowName=认证流程`,
                });
              }
            });
          } else {
            // 如果出错，给出提示
            // 如果innerCode等于7776，则跳转至人工审核页面
            this.updateIdCardInfoFaceActive(this.renLian.webUrl, () => {
              this.btnStatus = 3;
              CusAlert(res.msg, () => {
                if (res.innerCode === 7776) {
                  this.replacePage('ManualAudit', {
                    idCardName: this.formData.idCardName,
                    // idCardNum: this.formData.idCardNum,
                    // token: this.token,
                    // product: this.product,
                  });
                }
              });
            });
          }
        })
        .catch(err => {
          CusLoadingClose();
          CusAlert(err.msg);
        });
    },
    // 重新拍照
    resetCameraInfo(name, staus = 1) {
      this[name].base64 = '';
      this[name].fileUrl = '';
      this[name].webUrl = '';
      name === 'renLian' && (this[name].photoTips = PUBLIC_FACE_PHOTO_TIPS);
      this.btnStatus = staus;
    },
    // 跳人工审核
    jumpManualAudit() {
      if (!this.renLian.webUrl) {
        CusToast('请先进行人脸识别');
        return;
      }
      this.updateIdCardInfoFaceActive(this.renLian.webUrl, () => {
        CusAlert('人工审核将在1个工作日内处理完成，是否确定申请人工审核', () => {
          CusAlert('已为您提交人工审核，请继续完成后续认证流程，否则将无法通过人工审核', () => {
            this.replacePage('ManualAudit', {
              idCardName: this.formData.idCardName,
              // idCardNum: this.formData.idCardNum,
              // token: this.token,
              // product: this.product,
            });
          });
        });
      });
    },
    // 人脸识别不同方式不同处理
    jumpToLiveness() {
      let data = null;
      switch (this.faceDetectActivity) {
        case 0: // 不做人脸识别，直接拍照片
          data = this.createPostMessage('renLian');
          wx.miniProgram.postMessage({ data });
          wx.miniProgram.redirectTo({
            url: '/pages/media/media',
          });
          break;
        case 1: // 小视
          CusAlert('尚未开通甄视科技的人脸识别服务，请更换其他服务');
          break;
        case 2: // 百度
          this.setLivingFacePopupStatus(true);
          this.$refs.liveness.drawBaiduSessionCode();
          break;
        case 3: // 云码通
          data = this.createPostMessage('ymt');
          wx.miniProgram.postMessage({ data });
          wx.miniProgram.redirectTo({
            url: '/pages/media/media',
          });
          break;
      }
    },
    // 创建向小程序传递消息的参数对象
    createPostMessage(imgTypeStr) {
      return {
        page: 'media',
        h5Page: 'IdCardInfo',
        imgType: imgTypeStr,
        btnStatus: this.btnStatus,
        idCardBatchNo: this.idCardBatchNo,
        rxWebUrl: encodeURIComponent(this.renXiang.webUrl.replace('?', '|')),
        idCardName: this.formData.idCardName,
        idCardNum: this.formData.idCardNum,
        address: this.formData.address,
        familyName: this.formData.familyName,
        birthday: this.formData.birthday,
        sex: this.formData.sex,
        office: this.formData.office,
        ghWebUrl: encodeURIComponent(this.guoHui.webUrl.replace('?', '|')),
        dateOfIssue: this.formData.dateOfIssue,
        dateOfInvalid: this.formData.dateOfInvalid,
        dateOf: this.formData.dateOf,
        rlWebUrl: encodeURIComponent(this.renLian.webUrl.replace('?', '|')),
      };
    },
    // 调用接口识别身份证正面信息
    getIdCardFrontUrlV2() {
      CusLoadingOpen();
      GetIdCardFrontUrlV2({
        url: this.renXiang.webUrl,
        batchNo: this.idCardBatchNo,
      }).then(res => {
        CusLoadingClose();
        if (res.code === 0) {
          this.formData.idCardName = res.data.Name;
          this.formData.idCardNum = res.data.IdCardNum;
          this.formData.address = res.data.Address;
          this.formData.familyName = res.data.FamilyName;
          this.formData.birthday = res.data.Birthday;
          this.formData.sex = res.data.Sex;
        } else {
          CusAlert(res.msg, () => {
            this.resetCameraInfo("renXiang");
          });
        }
      })
        .catch(() => {
          CusLoadingClose();
        });
    },
    // 调用接口识别身份证背面信息
    getIdCardBackUrlV2() {
      CusLoadingOpen();
      GetIdCardBackUrlV2({
        url: this.guoHui.webUrl,
        batchNo: this.idCardBatchNo
      }).then(res => {
        CusLoadingClose();
        if (res.code === 0) {
          // 现阶段此接口有BUG，未识别出背面时，code还是为0
          // 特用判断msg的方式补救一下
          if (res.msg !== "") {
            CusAlert(res.msg, () => {
              this.resetCameraInfo("guoHui");
            });
          }
          this.formData.office = res.data.Office;
          this.formData.dateOfIssue = res.data.DateOfIssue;
          this.formData.dateOfInvalid = res.data.DateOfInvalid;
          this.formData.dateOf = `${res.data.DateOfIssue} - ${res.data.DateOfInvalid}`;
        } else {
          CusAlert(res.msg, () => {
            this.resetCameraInfo("guoHui");
          });
        }
      })
        .catch(() => {
          CusLoadingClose();
        });
    },
    // 调用云码通的接口做人脸识别
    yMTivingThing() {
      CusLoadingOpen();
      YMTivingThing({ url: this.renLian.webUrl })
        .then(res => {
          CusLoadingClose();
          if (res.code === 0) {
            this.renLian.webUrl = this.renLian.webUrl;
            this.renLian.fileUrl = this.renLian.webUrl;
            this.renLian.base64 = this.renLian.webUrl;
            res.msg && CusAlert(res.msg);
          } else {
            CusAlert(res.msg, () => {
              this.renLian.webUrl = "";
              this.renLian.fileUrl = "";
              this.renLian.base64 = "";
              this.btnStatus = 3;
            });
          }
        })
        .catch(() => {
          CusLoadingClose();
        });
    },
  },
};
</script>
